import * as angular from 'angular';
import OrderNumberFilter from './order.number.filter.js';
import UniqueNumberLabel from './unique.order.number.label';
import OrderNumberService from './order.number.service';
import ExistsNumber from './existsNumber/exists.number';
import ExistsNumberTopBar from './existsNumber/topBar/exists.number.top.bar';
import ExistsNumberValidate from './existsNumber/validateNumber/exists.number.validate';
import ExistsNumberValidateCode from './existsNumber/validateCode/exists.number.validate.code';
import CodeInput from './existsNumber/validateCode/codeInput';
import VerificationNumberService from './existsNumber/verification.number.service';

export default angular.module('CrazyWeb.OrderNumber', [])
    .component('existsNumber', ExistsNumber)
    .component('existsNumberTopBar', ExistsNumberTopBar)
    .component('existsNumberValidate', ExistsNumberValidate)
    .component('existsNumberValidateCode', ExistsNumberValidateCode)
    .directive("uniqueNumberLabel", UniqueNumberLabel)
    .directive('codeInput', CodeInput)
    .service("OrderNumberService", OrderNumberService)
    .service("VerificationNumberService", VerificationNumberService)
    .filter("orderNumberFilter", OrderNumberFilter).name
